<template>
    <div class="resource">
        <div v-if="check=='march'" id="check">
            <p>
                <i class="el-icon-loading loading"></i>
            </p>
            <p>请稍等，资源正在加载中{{ loadingico }}
            </p>
            <p>如出现错误请多尝试几次或者换用其他入口</p>
            <p>如不能正常使用请告知客服修复</p>
            <p style="color:red">加载中请勿刷新页面, 请等待加载完成</p>
        </div>
        <div id="astrict" v-else-if="check=='astrict'">
            <p>
                <i class="el-icon-lock loading"></i>
            </p>
            <p v-if="check_user_condition==1">
                您访问的资源要求用户组为&nbsp;:&nbsp;
                <span v-if="check_user_condition==1" style="color:red">{{all_group}}</span>
                </p>
            <p v-if="check_user_condition==1">但您当前所在的用户组为&nbsp;:&nbsp;<span style="color:red">{{group}}</span></p>
            <p v-if="check_user_condition==1">
                请&nbsp;<a href="/main">返回资源列表</a>&nbsp;选择属于您的权限组的资源
                <span class="occupied"></span>
                或&nbsp;<a href="/pay">升级会员组</a>&nbsp;后再进行访问</p>
            <p v-if="check_user_condition==2">您的会员权限已到期, 请点"充值与续费"进行充值后继续使用</p>
            <p v-if="check_user_condition==2"><a href="/main">返回资源列表</a><span class="occupied"></span><a href="/pay">充值与续费</a></p>
        </div>
        <div id="error" v-else-if="check=='error'">
            <p>{{ msg }}</p>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                status: true,
                check: "march",
                all_group: null,
                group: null,
                check_user_condition: null,
                msg: '',
                loadingico: '',
                loadindex: 0,
            }
        },
        created () {
            setInterval(()=>{this.loadingicofun()}, 1000);
        },
        mounted () {
            var code = this.$route.query.code
            if (code){
                this.request_user_condition()
            }else{
                this.$router.push({"path": "/main"})
            }
        },
        methods: {
            loadingicofun () {
                this.loadindex += 1;
                this.loadingico = '';
                for (let i = 0; i < this.loadindex%6; i++) {
                    this.loadingico += ".";
                }
            },
            request_user_condition () {
                let param = new URLSearchParams();
                param.append("code", this.$route.query.code);
                this.$http.postResLink(param).then(resp=>{
                    if (resp.code==402){
                        this.check = 'astrict';
                        this.check_user_condition = 1
                        this.all_group = resp.all_group
                        this.group = resp.group
                    }else if (resp.code==403) {
                        this.check = 'astrict';
                        this.check_user_condition = 2
                    }else if (resp.code==404) {
                        this.$message.error('登录信息失效，请重新登陆！')
                        localStorage.removeItem('login_info')
                        this.$router.push({path: '/login'})
                    } else if (resp.code==200) {
                        const meta = document.createElement('meta'); 
                        meta.name  = 'referrer';
                        meta.content  = 'no-referrer';
                        document.head.appendChild(meta); 
                        location.href = resp.link;
                    } else if (resp.code==201) {
                        const meta = document.createElement('meta'); 
                        meta.name  = 'referrer';
                        meta.content  = 'no-referrer';
                        document.head.appendChild(meta); 
                        const form = document.createElement('form');
                        form.rel = 'noreferrer';
                        form.method = 'POST';
                        form.action = resp.link;
                        const parameter = document.createElement('input');
                        parameter.type = 'hidden';
                        parameter.name = 'sharedSPMessage';
                        parameter.value = resp.value;
                        form.appendChild(parameter);
                        document.body.appendChild(form);
                        form.submit();
                    } else if (resp.code==202) {
                        document.open();
                        document.write(resp.html);
                        document.close();
                    } else if (resp.code==500) {
                        this.check = 'error';
                        this.msg = resp.msg;
                    }
                })
            }
        }
    }
</script>
<style scoped>
    .resource {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        margin-top: 100px;
    }

    .resource p {
        margin-top: 20px;
    }

    .loading {
        font-size: 40px;
    }

    .load {
        display: inline-block;
        width: 20px;
        text-align: left;
    }

    .occupied {
        padding: 0 20px;
    }
    #error p {
      text-align: center;
      font-size: 18px;
      color: red;
      margin-top: 15vh;
    }
</style>